"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tagged = tagged;
const incrementPendingClassMetadataCount_1 = require("../actions/incrementPendingClassMetadataCount");
const updateMetadataTag_1 = require("../actions/updateMetadataTag");
const buildMaybeClassElementMetadataFromMaybeClassElementMetadata_1 = require("../calculations/buildMaybeClassElementMetadataFromMaybeClassElementMetadata");
const injectBase_1 = require("./injectBase");
function tagged(key, value) {
    const updateMetadata = (0, buildMaybeClassElementMetadataFromMaybeClassElementMetadata_1.buildMaybeClassElementMetadataFromMaybeClassElementMetadata)((0, updateMetadataTag_1.updateMetadataTag)(key, value));
    return (0, injectBase_1.injectBase)(updateMetadata, incrementPendingClassMetadataCount_1.incrementPendingClassMetadataCount);
}
//# sourceMappingURL=tagged.js.map